import * as Yup from 'yup';
import i18n from '../../translation/config';

const refundsOrderForm = () =>
  Yup.object().shape({
    orderId: Yup.number().required(i18n.t('refunds-form-order-is-required')),
  });

export const refundEmailForm = () =>
  Yup.object().shape({
    email: Yup.string().email(i18n.t('enter-valid-email')).required(i18n.t('email-required')),
  });

export default refundsOrderForm;
